import DocAbi from "./abis/Docthereum.json";


const abis = {
  docthereum: DocAbi,
 
};

export default abis;
